<template>
  <input
    class="gs-date"
    type="date"
    :value="current"
    :disabled="disabled"
    @input="onInput"
  >
</template>

<script>
export default {
  name: 'GsDate',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    current() {
      const raw = this.value != null && this.value !== '' ? this.value : this.modelValue
      return raw ? String(raw).slice(0, 10) : ''
    }
  },
  methods: {
    onInput(event) {
      const next = event && event.target ? event.target.value : ''
      this.$emit('input', next)
      this.$emit('change', next)
      this.$emit('update:modelValue', next)
      this.$emit('update:model-value', next)
    }
  }
}
</script>

<style scoped>
.gs-date {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #D7DEE8;
  border-radius: 4px;
  padding: 0 10px;
  background: #fff;
  color: #1f2937;
  font-size: 14px;
  outline: none;
}
.gs-date:focus {
  border-color: #0165FF;
}
.gs-date:disabled {
  background: #F5F7FA;
  color: #C0C4CC;
}
</style>
